document.documentElement.classList.remove('no-js');

function ready(fn){if(document.readyState !== 'loading'){fn();}else{document.addEventListener('DOMContentLoaded',fn);}}

ready(function(){
  document.querySelectorAll('[data-menu-toggle]').forEach(function(button){
    button.addEventListener('click',function(){
      var nav=document.querySelector('[data-mobile-nav]');
      if(!nav)return;
      var open=nav.classList.toggle('is-open');
      button.setAttribute('aria-expanded',open ? 'true' : 'false');
    });
  });

  document.querySelectorAll('[data-fitment-form]').forEach(function(form){
    form.addEventListener('submit',function(){
      var parts=[];
      form.querySelectorAll('[data-fitment-part]').forEach(function(input){
        if(input.value && input.value.trim().length){parts.push(input.value.trim());}
      });
      var query=form.querySelector('[data-fitment-query]');
      if(query){query.value=parts.join(' ');}
    });
  });

  document.querySelectorAll('.product-form').forEach(function(form){
    var select=form.querySelector('[data-variant-select]');
    var price=form.closest('[data-product-root]')?.querySelector('[data-product-price]');
    var submit=form.querySelector('[data-add-to-cart]');
    var jsonEl=form.querySelector('[data-variant-json]');
    if(!select || !jsonEl)return;
    var variants=[];
    try{variants=JSON.parse(jsonEl.textContent || '[]');}catch(e){variants=[];}
    var formatMoney=function(cents){
      try{
        return new Intl.NumberFormat(document.documentElement.lang || 'nl-NL',{style:'currency',currency:window.Shopify?.currency?.active || 'EUR'}).format(cents/100);
      }catch(e){return (cents/100).toFixed(2);}
    };
    select.addEventListener('change',function(){
      var selected=variants.find(function(v){return String(v.id)===String(select.value);});
      if(!selected)return;
      if(price){price.textContent=formatMoney(selected.price);}
      if(submit){
        submit.disabled=!selected.available;
        submit.textContent=selected.available ? submit.getAttribute('data-available-text') : submit.getAttribute('data-soldout-text');
      }
    });
  });
});
